












import Vue from 'vue';
import { TokenType, Token, TextLiteralToken, VariableToken, CommandToken, CommandType, Variables } from './Types';

export default Vue.extend({
    name: 'TokenListItem',
    data() {
        return {
            TokenType,
            CommandType
        };
    },
    props: {
        token: {
            type: Object as () => Token
        },
        selected: {
            type: Boolean
        }
    },
    computed: {
        tokenValue(): string {
            let tokenValue = '';

            switch (this.token.tokenType) {
                case TokenType.TextLiteral:
                    tokenValue = (this.token as TextLiteralToken).contents;
                    break;
                case TokenType.Variable:
                    tokenValue = this.$options.filters?.splitCamelCase(`${Variables[(this.token as VariableToken).variableName as any]}`);
                    break;
                case TokenType.Command:
                    tokenValue = this.$options.filters?.splitCamelCase(`${CommandType[(this.token as CommandToken).commandType]}`);
                    break;
            }

            return tokenValue;
        },
        tokenDescriptor(): string {
            if (this.token.tokenType !== TokenType.TextLiteral) {
                return this.$options.filters?.splitCamelCase(TokenType[this.token.tokenType]);
            }
            else {
                return this.$t('admin.ticketTemplateBuilder.literalToken.textLabel').toString();
            }
        },
    },
    methods: {
        select() {
            this.$emit('tokenSelected', this.token);
        },
        deleteToken() {
            this.$emit('tokenDeleted', this.token);
        }
    }
});
